/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, January 2022
 * @format
 * @flow
 */

import { useCallback, useEffect, useState } from 'react';
import UTIL from 'mroads-js-utils';
import { TimeConstants } from '../constants';

const useElapsedTime = (closeDate) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    updateTime();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      updateTime();
    }, 60 * 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const updateTime = useCallback(() => {
    if (closeDate) {
      const elapsedTime = getElapsedTime(); //in milliseconds
      setElapsedTime(elapsedTime);
    }
  }, []);

  const getElapsedTime = useCallback(() => {
    const currentTime = new Date().getTime();
    const dueTime = closeDate;
    let date;
    if (dueTime && dueTime.includes('Z'))
      date = new Date(dueTime);
    else
      date = new Date(dueTime + 'Z');
    const closeTime = new Date(date).getTime();
    return currentTime - closeTime;
  }, []);

  const getElapsedTimeInHrMinSec = useCallback((elapsedTime) => {
    if (!elapsedTime)
      return "- -";
    const time = Math.abs(elapsedTime);
    const convertedTimeInSeconds = parseInt(time / TimeConstants.SECOND);
    if (convertedTimeInSeconds < 60)
      return `${UTIL.round(convertedTimeInSeconds, 0)}s`;
    const convertedTimeInMinutes = convertedTimeInSeconds / 60;
    if (convertedTimeInMinutes < 120)
      return `${UTIL.round(convertedTimeInMinutes, 0)}m`;
    return "2h+";
  }, []);

  return {
    elapsedTimeInMillisecond: elapsedTime,
    elapsedTimeInHrMinSec: getElapsedTimeInHrMinSec(elapsedTime),
  };
};

export default useElapsedTime;
